import script from "./HomeButtonCustomer.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeButtonCustomer.vue?vue&type=script&setup=true&lang=js"

import "./HomeButtonCustomer.vue?vue&type=style&index=0&id=3f8c62a0&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f8c62a0"]])

export default __exports__